import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { getDriverDebtModalColumns } from '../config';
import { useGetOpenReturnShippingsByDriverQuery } from '../services';
import { Close as CloseIcon } from '@mui/icons-material';
import { ReturnsIntakeByDriverItem } from '../models';
import { Table } from '@/components';
import { useMemo } from 'react';
import { appUrl } from '@/utils/appUrl';

interface DriverDebtModalProps {
  driverId: string;
  driverName: string;
  onClose: () => void;
}

const DriverDebtModal = ({ driverId, driverName, onClose }: DriverDebtModalProps) => {
  const { data, isLoading } = useGetOpenReturnShippingsByDriverQuery({ driverId });
  const shippings: ReturnsIntakeByDriverItem[] = data?.shippings || [];

  const columns = useMemo(() => getDriverDebtModalColumns(), []);

  return (
    <Dialog open onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle className='flex items-center justify-between pr-3'>
        <div className='flex flex-col'>
          <span className='text-2xl font-black text-slate-800'>Devoluciones pendientes</span>
          <span
            className='text-base font-medium text-orange-500 hover:underline cursor-pointer w-fit'
            onClick={() => window.open(appUrl(`/business/drivers/${driverId}`), '_blank')}
          >
            {driverName}
          </span>
        </div>
        <IconButton onClick={onClose} size='small'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0, maxHeight: '70vh', overflowY: 'auto' }}>
        {!isLoading && !shippings.length ? (
          <p className='text-center text-gray-400 italic py-12'>No hay pedidos pendientes.</p>
        ) : (
          <Table
            columns={columns}
            data={shippings}
            isLoading={isLoading}
            getRowKey={(row) => String(row.shippingNumber)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DriverDebtModal;
